export const itSupportData = {
  stats: {
    openTickets: 12,
    resolvedToday: 8,
    avgResponseTime: '2.5h',
    activeAssets: 156,
    ticketTrends: [
      { date: 'Mon', tickets: 12, resolved: 10 },
      { date: 'Tue', tickets: 15, resolved: 12 },
      { date: 'Wed', tickets: 8, resolved: 8 },
      { date: 'Thu', tickets: 14, resolved: 11 },
      { date: 'Fri', tickets: 18, resolved: 15 },
      { date: 'Sat', tickets: 10, resolved: 9 },
      { date: 'Sun', tickets: 5, resolved: 5 }
    ],
    ticketCategories: {
      'Store Hardware': 35,
      'Store Software': 28,
      'HQ Systems': 20,
      'Network Issues': 15,
      'User Access': 12,
      'Other': 5
    },
    ticketsByLocation: {
      'Store #123': 15,
      'Store #456': 12,
      'Store #789': 10,
      'HQ': 25,
      'Warehouse': 8
    },
    systemStatus: {
      servers: { status: 'operational', uptime: '99.9%' },
      network: { status: 'operational', uptime: '98.9%' },
      security: { status: 'operational', lastIncident: '45d ago' },
      services: { status: 'partial', affectedServices: ['Email'] }
    }
  },
  recentTickets: [
    {
      id: 'T-1001',
      title: 'POS System Not Responding',
      priority: 'high',
      status: 'open',
      requester: 'John Smith',
      location: 'Store #123',
      category: 'Store Hardware',
      createdAt: '2024-02-15T10:30:00',
      assignedTo: 'Mike Tech'
    },
    {
      id: 'T-1002',
      title: 'Printer Connection Issues',
      priority: 'medium',
      status: 'in-progress',
      requester: 'Sarah Johnson',
      location: 'Store #456',
      category: 'Store Hardware',
      createdAt: '2024-02-15T09:15:00',
      assignedTo: 'Tech Team'
    },
    {
      id: 'T-1003',
      title: 'Email Not Working',
      priority: 'low',
      status: 'resolved',
      requester: 'Mike Brown',
      location: 'HQ',
      category: 'HQ Systems',
      createdAt: '2024-02-15T08:45:00',
      assignedTo: 'System Admin'
    },
    {
      id: 'T-1004',
      title: 'Security Camera Offline',
      priority: 'high',
      status: 'open',
      requester: 'Lisa Davis',
      location: 'Store #234',
      category: 'Store Hardware',
      createdAt: '2024-02-15T08:00:00',
      assignedTo: null
    }
  ],
  ticketCategories: [
    {
      name: 'Store Hardware',
      description: 'POS, Printers, Scanners',
      icon: 'Monitor'
    },
    {
      name: 'Store Software',
      description: 'POS Software, Reports',
      icon: 'FileText'
    },
    {
      name: 'HQ Systems',
      description: 'Email, ERP, CRM',
      icon: 'Server'
    },
    {
      name: 'Network Issues',
      description: 'Internet, VPN, WiFi',
      icon: 'Wifi'
    },
    {
      name: 'User Access',
      description: 'Logins, Permissions',
      icon: 'Key'
    }
  ]
}; 